import { render, staticRenderFns } from "./NewCalculatorComponent.vue?vue&type=template&id=8b992a2a&scoped=true&"
import script from "./NewCalculatorComponent.vue?vue&type=script&lang=js&"
export * from "./NewCalculatorComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewCalculatorComponent.vue?vue&type=style&index=0&id=8b992a2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b992a2a",
  null
  
)

export default component.exports